module.exports = __webpack_public_path__ + "img/sword-air-05.2c7db84b.png";